import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Input, Row, Col } from "reactstrap"; // Spinner is not used in this form
import DatePicker from "react-multi-date-picker";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { DateCalendar, PickersDay } from '@mui/x-date-pickers';
// import { styled } from '@mui/material/styles';


dayjs.extend(customParseFormat);

const AddCourseSessionForm = ({
    labels,
    formikProps,
    isAddOrEdit,
    Module,
    CourseSessions,
}) => {
    const { t, i18n } = useTranslation();
    const datePickerRef = useRef(null);
    const isRTL = i18n.dir() === "rtl";

    const { values, errors, touched, handleChange, handleBlur, setFieldValue, setFieldTouched } = formikProps;

    const { Users } = useSelector((state) => ({
        Users: state.Users.users,
    }));

    // Handle outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
                 if (datePickerRef.current.hasOwnProperty('closeCalendar') && typeof datePickerRef.current.closeCalendar === 'function') { // defensive check
                      datePickerRef.current.closeCalendar();
                 }
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // const CustomPickersDay = styled(PickersDay, {
    //     shouldForwardProp: (prop) => prop !== 'isSelected',
    //     })(({ theme, isSelected }) => ({
    //     ...(isSelected && {
    //         backgroundColor: theme.palette.primary.main,
    //         color: theme.palette.common.white,
    //         '&:hover, &:focus': {
    //         backgroundColor: theme.palette.primary.dark,
    //         },
    //     }),
    // }));

    // function renderWeekDay(date, selectedDates) {
    //     const dateStr = date.format('YYYY-MM-DD');
    //     const isSelected = selectedDates.includes(dateStr);

    //     return (
    //         <CustomPickersDay
    //         key={dateStr}
    //         day={date}
    //         isSelected={isSelected}
    //         onClick={() => handleDateClick(date)}
    //         />
    //     );
    // }

    // const handleDateClick = (date) => {
    //     const newDateStr = date.format('YYYY-MM-DD');
    //     let currentDates = Array.isArray(values[fieldName]) ? [...values[fieldName]] : [];
    //     const limit = values.NoOfSessions ? parseInt(values.NoOfSessions, 10) : Infinity;

    //     const isAlreadyScheduled = (CourseSessions || [])
    //         .filter(s => s.SessionStatusID !== "4")
    //         .map(s => dayjs(s.StartDate).format('YYYY-MM-DD'))
    //         .includes(newDateStr);

    //     const allowedDaysIndices = Module?.Days?.map((d) => d % 7) || [];
    //     const isAllowedDay = allowedDaysIndices.length > 0 ? allowedDaysIndices.includes(date.day()) : true;

    //     if (!isAllowedDay || isAlreadyScheduled) {
    //         return; // optionally toast error
    //     }

    //     if (currentDates.includes(newDateStr)) {
    //         currentDates = currentDates.filter(d => d !== newDateStr);
    //     } else if (currentDates.length < limit) {
    //         currentDates.push(newDateStr);
    //     }

    //     setFieldValue(fieldName, currentDates);
    // };



    // const [currentSessionDatePick, setCurrentSessionDatePick] = useState(null);

    const renderField = (item) => {
        const fieldName = item.name;
        const fieldValue = values[fieldName];
        const isInvalid = touched[fieldName] && !!errors[fieldName];

        switch (item.fieldName) {
            case 'text-box':
                return (
                    <Input
                        type="text"
                        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                        placeholder={t(item.placeholder || item.labelName)}
                        value={fieldValue || ''} // Ensure value is not null/undefined
                        name={item.name}
                        onChange={handleChange}
                        id={item.name}
                        onBlur={handleBlur}
                        required={item.required}
                        // disabled={isDisabled}
                    />
                );

            case 'textarea-box':
                return (
                    <Input
                        rows="4"
                        type="textarea"
                        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                        placeholder={t(item.placeholder || item.labelName)}
                        value={fieldValue || ''} // Ensure value is not null/undefined
                        name={item.name}
                        onChange={handleChange}
                        id={item.name}
                        onBlur={handleBlur}
                        required={item.required}
                    />
                );

           case 'number-box':
                return (
                    <Input
                        type="number"
                        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                        placeholder={t(item.placeholder || item.labelName)}
                        value={fieldValue || ''} // Ensure value is not null/undefined
                        name={item.name}
                        onChange={handleChange}
                        id={item.name}
                        onBlur={handleBlur}
                        required={item.required}
                        dir={isRTL ? 'rtl' : 'ltr'}
                        style={{ textAlign: isRTL ? 'right' : 'left' }}
                    />
                );

            case 'date':
                return (
                    <Input
                        type="date"
                        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                        id={item.name}
                        name={item.name}
                        min={(Module?.StartDate || '')?.split('T')[0]}
                        value={(fieldValue || '')?.split('T')[0]}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required={item.required}
                        dir={isRTL ? 'rtl' : 'ltr'}
                        style={{ textAlign: isRTL ? 'right' : 'left' }}
                        placeholder={t(item.placeholder || item.labelName)}
                    />
                );


            case 'time':
                
                return (
                    <Input
                        type="time"
                        className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                        id={item.name}
                        name={item.name}
                        value={
                            fieldValue
                            ? dayjs(fieldValue, ['hh:mm:ss A', 'hh:mm A', 'HH:mm:ss', 'HH:mm']).format('HH:mm')
                            : ''
                        }
                        onChange={(e) => {
                            const timeValue = e.target.value; 
                            const normalized = `${timeValue}:00`; 
                            setFieldValue(item.name, normalized);
                        }}
                        dir={isRTL ? 'rtl' : 'ltr'}
                        style={{ textAlign: isRTL ? 'right' : 'left' }}
                        onBlur={handleBlur}
                        required={item.required}
                    />
                );


            case "date-picker":
                let datePickerValueProp;
                if (isAddOrEdit === "isEdit") {
                    const currentFormikValue = values[item.name];
                    // Ensure a valid Date object or null is passed to DatePicker
                    datePickerValueProp = (currentFormikValue && dayjs(currentFormikValue).isValid())
                        ? dayjs(currentFormikValue).toDate()
                        : null;
                } else { // isAdd
                    const currentFormikArray = values[item.name];
                    // Ensure an array of valid Date objects is passed, filtering out invalids
                    datePickerValueProp = Array.isArray(currentFormikArray)
                        ? currentFormikArray
                            .map(dateString => {
                                const d = dayjs(dateString);
                                return d.isValid() ? d.toDate() : null;
                            })
                            .filter(Boolean) // Remove nulls from invalid dates
                        : [];
                }
                const datePickerIsInvalid = touched[item.name] && !!errors[item.name];
                const numSessions = values.NoOfSessions ? parseInt(values.NoOfSessions, 10) : 0;

                return (
                  <DatePicker ref={datePickerRef}
                    inputClass={`form-control ${datePickerIsInvalid ? 'is-invalid' : ''}`}
                    multiple={isAddOrEdit === "isAdd"}
                    value={datePickerValueProp}
                    disabled={isAddOrEdit === "isAdd" && !values['NoOfSessions']}
                    mapDays={({ date }) => {
                      const day = date.weekDay.index;
                      const allowedDays = Module?.Days?.map((d) => d % 7) || [];
                      const dateStr = dayjs(date.toDate()).format('YYYY-MM-DD'); // Use dayjs for formatting

                      const currentSelectedDatesRaw = values[item.name] || (isAddOrEdit === "isAdd" ? [] : null);
                      const currentSelectedDatesISO = (
                          Array.isArray(currentSelectedDatesRaw)
                              ? currentSelectedDatesRaw
                              : (currentSelectedDatesRaw ? [currentSelectedDatesRaw] : [])
                          )
                          .map(d => dayjs(d).isValid() ? dayjs(d).format('YYYY-MM-DD') : null ) // Use dayjs
                          .filter(d => d);
                      const selectedCount = currentSelectedDatesISO.length;

                      if (!allowedDays.includes(day)) {
                        return {
                            disabled: true,
                            className: "disabled-date-course-day",
                            style: { color: "#aaa" }
                        };
                    }

                      let scheduledDatesToDisable = [];
                      if (isAddOrEdit === "isAdd") {
                        scheduledDatesToDisable = CourseSessions
                          ?.filter(s => s.SessionStatusID !== "4")
                          .map(s => dayjs(s.StartDate).format('YYYY-MM-DD')); // Use dayjs
                      } else { // isEdit
                        scheduledDatesToDisable = CourseSessions
                          ?.filter(s => s.ID !== values.ID && s.SessionStatusID !== "4")
                          .map(s => dayjs(s.StartDate).format('YYYY-MM-DD')); // Use dayjs
                      }

                      if (scheduledDatesToDisable.includes(dateStr)) {
                        return {
                            disabled: true,
                            className: "disabled-date",
                            style: { color: "#aaa", textDecoration: "line-through" }
                        };
                      }

                      if (
                        isAddOrEdit === "isAdd" &&
                        numSessions > 0 &&
                        selectedCount >= numSessions &&
                        !currentSelectedDatesISO.includes(dateStr)
                      ) {
                        return {
                            disabled: true,
                            className: "disabled-date-used-module",
                            style: { color: "#aaa"}
                        };
                      }
                      return {};
                    }}
                    onChange={(dates) => {
                      if (isAddOrEdit === "isAdd") {
                        const dateObjects = Array.isArray(dates) ? dates : (dates ? [dates] : []);
                         let sessionLimit = 0;
                        const numSessionsStr = values.NoOfSessions;
                        if (numSessionsStr) {
                            const parsedLimit = parseInt(numSessionsStr, 10);
                            if (!isNaN(parsedLimit) && parsedLimit > 0) {
                                sessionLimit = parsedLimit;
                            }
                        }
                        // If sessionLimit is 0 (e.g. NoOfSessions not positive), take all dates user picked.
                        // This path should ideally not be hit if DatePicker is disabled when NoOfSessions is not positive.
                        const actualLimit = sessionLimit > 0 ? sessionLimit : dateObjects.length;
                        const limitedDates = dateObjects.slice(0, actualLimit);
                        const isoDates = limitedDates.map(d =>
                          dayjs(d.toDate()).format('YYYY-MM-DD') // Use dayjs (DatePicker objects might need .toDate())
                        );
                        setFieldValue(item.name, isoDates);
                      } else { // isEdit
                        const dateToSet = dates instanceof Date ? dates : (Array.isArray(dates) && dates.length > 0 ? dates[0] : null);
                        // DatePicker might return its own object type, ensure it's converted to Date if necessary
                        const finalDate = dateToSet ? (dateToSet instanceof Date ? dateToSet : dateToSet.toDate()) : null;
                        setFieldValue(item.name, finalDate ? dayjs(finalDate).format('YYYY-MM-DD') : null); // Use dayjs
                      }
                        setFieldTouched(item.name, true, true);
                    }}
                    format="MMM D, YYYY"
                    placeholder={t(item.placeholder || 'SelectDates')}
                    minDate={Module?.StartDate && dayjs(Module.StartDate).isValid() 
                                ? dayjs(Module.StartDate).toDate() 
                                : undefined }
                    onClose={() => setFieldTouched(item.name, true, true)}
                  />

                );
            // case "date-picker":
            //     const isMultipleDatesField = isAddOrEdit === 'isAdd' && item.name === 'SessionDates';
            //     const muiDatePickerIsInvalid = touched[fieldName] && !!errors[fieldName];

            //     let muiDateValue;
            //     if (isMultipleDatesField) {
            //         muiDateValue = currentSessionDatePick ? dayjs(currentSessionDatePick) : null;
            //     } else { // Single date field (edit mode)
            //         muiDateValue = fieldValue ? dayjs(fieldValue) : null;
            //     }

            //     return (
            //    <LocalizationProvider dateAdapter={AdapterDayjs}>
            //         <DateCalendar
            //             value={null} // calendar stays open
            //             minDate={Module?.StartDate ? dayjs(Module.StartDate) : undefined}
            //             shouldDisableDate={(date) => {
            //             const dayIndex = date.day();
            //             const allowedDaysIndices = Module?.Days?.map((d) => d % 7) || [];
            //             if (allowedDaysIndices.length > 0 && !allowedDaysIndices.includes(dayIndex)) return true;

            //             const dateStr = date.format('YYYY-MM-DD');
            //             const scheduledDatesToDisable = (CourseSessions || [])
            //                 .filter(s => s.SessionStatusID !== "4")
            //                 .map(s => dayjs(s.StartDate).format('YYYY-MM-DD'));

            //             if (scheduledDatesToDisable.includes(dateStr)) return true;

            //             const selected = Array.isArray(values[fieldName]) ? values[fieldName] : [];
            //             const limit = values.NoOfSessions ? parseInt(values.NoOfSessions, 10) : Infinity;
            //             if (selected.length >= limit && !selected.includes(dateStr)) return true;

            //             return false;
            //             }}
            //             slots={{
            //             day: (props) => {
            //                 const selectedDates = Array.isArray(values[fieldName]) ? values[fieldName] : [];
            //                 return renderWeekDay(props.day, selectedDates);
            //             }
            //             }}
            //         />
            //     </LocalizationProvider>
            //     );

            case 'tutor-dropdown':
                let isTutorFieldDisabled = false;
                if (item.name === "TutorID") {
                    if (isAddOrEdit === 'isAdd') {
                        isTutorFieldDisabled = !!Module?.TutorID;
                    } else {
                        isTutorFieldDisabled = true;
                    }
                }

                return (
                    <select className={`form-control ${isInvalid ? 'is-invalid' : ''}`}
                        id={item.name}
                        name={item.name}
                        value={String(fieldValue ?? '')}
                        onChange={handleChange}
                        required={item.required}
                        disabled={isTutorFieldDisabled}
                        onBlur={handleBlur}
                    >
                        <option value="">{t("Choose")}</option>
                        {(Users || []).map((user) => (
                                <option value={String(user?.Id)} key={user?.Id}>{user?.FullName}</option>
                            ))
                        }
                    </select>
                );

            default:
                console.warn(`AddCourseSessionForm: Unknown field type for item "${item.name}". Field definition:`, item);
                return null;
        }
    };

    return (
        <Row>
            {labels?.map((item, index) => { // Added index for fallback key
                const key = item.id ?? item.name ?? `field-${index}`; // More robust key generation
                if (!(item.id || item.name)) {
                    console.error("AddCourseSessionForm: Label item is missing a unique 'id' or 'name' for its key. Using index as fallback.", item);
                }
                return (
                    <Col sm={6} key={key}>
                        <div className="mb-3">
                            <label htmlFor={item.name} className="col-form-label">
                                {t(item.labelName)}
                                {item.required && <small className="text-danger"> *</small>}
                            </label>
                            {renderField(item)}
                            {touched[item.name] && errors[item.name] && (
                                <div className="invalid-feedback d-block">
                                    {typeof errors[item.name] === 'string' ? t(errors[item.name]) : String(errors[item.name])}
                                </div>
                            )}
                        </div>
                    </Col>
                );
            })}
        </Row>
    );
};

export default AddCourseSessionForm;